import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import history from './utils/history';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './configureStore';
import { ConnectedRouter } from 'connected-react-router';

const initialState = {};
const store = configureStore(initialState, history);

let courseFilterDisplay = document.getElementById('search-base');

if (!courseFilterDisplay) {
  courseFilterDisplay = document.getElementById('search-inner');
}
const location = courseFilterDisplay.getAttribute('data-location');
const structure = courseFilterDisplay.getAttribute('data-structure');

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <App location={location} structure={structure} />
      </ConnectedRouter>
    </Provider>
  </React.StrictMode>,
  courseFilterDisplay,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
